import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  footer: {
    backgroundColor: "transparent",
    marginTop: 40,
  },
  inner: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingTop: "25px",
    paddingBottom: "25px",
    borderTopColor: theme.colors.gray[1],
    borderTopStyle: "solid",
    borderTopWidth: "1px",
  },
  text: {
    fontSize: "14px",
    fontWeight: "bold",
    color: theme.colors.gold[0],

    "&:hover": {
      cursor: "pointer",
    },
  },
  copyright: {
    color: theme.colors["deep-blue"][0],
    fontSize: "10px",
    fontWeight: "bold",
  },
}));

export default useStyles;
